import { ROUTE } from "@/constants/routes";
import { setNamespace, socket } from "@/hooks/socket";
import { formatLocal } from "@/lib/utils";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { toast } from "sonner";
import { ExamDoneReason } from "./ExamDone/exam-done-reason.enum";
import { ExamContext } from "./exam.context";
import { useSocketStore } from "@/hooks/useSocketStore";

const Exam = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const isTest = searchParams.get("test") === "true";
  const { setExamFinished } = useSocketStore();

  // bind right namespace to socket
  useEffect(() => {
    setNamespace(isTest ? "test" : undefined);
  }, [isTest]);

  // disconnect socket
  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, []);

  // add listeners
  useEffect(() => {
    // exam finished
    socket.on("examFinished", () =>
      navigate(ROUTE.exam.done(ExamDoneReason.AdminsClosed)),
    );

    // additional time
    socket.on("plannedFinishTime", (plannedFinishTime: Date) => {
      toast.success("Nouvel horaire de fin", {
        description: `Votre horaire de fin est maintenant ${formatLocal(
          plannedFinishTime,
          "HH:mm",
        )}.`,
      });
    });

    // connection refused
    socket.on("connectionRefused", (reason: string) => {
      toast.error("Déconnexion", { description: reason });
      navigate(ROUTE.exam.login());
      socket.disconnect();

      // Set exam finished to prevent reconnection
      if (
        reason === "Temps épuisé" ||
        reason === "Examen déjà soumis" ||
        reason === "Examen fermé par les administrateurs"
      ) {
        setExamFinished(true);
      }
    });

    return () => {
      socket.off("examFinished");
      socket.off("connectionRefused");
    };
  }, [navigate, setExamFinished]);

  const context: ExamContext = {
    isTest,
  };

  return <Outlet context={context} />;
};

export default Exam;
